import { Button, Div, Label } from '@grassrootly/rn-core';
import { DrawerNavigationProp } from '@react-navigation/drawer';
import { MainStackParamList } from '../../../navigation/Navigation.types';
import { IPlayerGroup } from '@grassrootly/api';

export type CreateNewGameCTAProps = {
  navigation: DrawerNavigationProp<MainStackParamList>;
  groups: IPlayerGroup[];
};

export default function CreateNewGameCTA(props: CreateNewGameCTAProps) {
  return (
    <Div classNames={["textCenter", "alignContentCenter", "alignItemsCenter", "maxW-{400}", "mt-{30}", "ml-{auto}", "mr-{auto}"]}>
      <Label classNames={["l1Bold", "mt-{15}"]}>You currently do not have a upcoming match. Create your next ⚽ here!</Label>
      <Div classNames={["mt-{20}"]}>
        <Button
          title="Schedule New Match"
          classNames={["btn", "btnPrimary", "m-{auto}"]}
          right={{ name: "sports_soccer" }}
          onPress={() => props.navigation.navigate("new-game", {})}
        />
      </Div>
    </Div>
  );
};